import React, {Component} from 'react';
import './styles.less';

class Message extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {duration = 5, onClose} = this.props;
    setTimeout(onClose, duration * 1000);
  }

  render() {
    const {message = '', type = 'alert'} = this.props;
    return <p className={`zast-message-component ${type}`}>{message}</p>;
  }
}

export default Message;
